import { IApplicationState } from '../../../common/types/redux';

export const selectMapBounds = (state: IApplicationState) => {
  return state.map.mapBounds;
};
